import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TilingSprite, useTick } from '@pixi/react';
import { useCallback, useEffect, useRef } from 'react';
import { isConfigFlagEnabled } from '../../../../config';
import { useAppSelector } from '../../../../redux/store';
const DELTA_FACTOR = 0.1;
const ALL_DIRECTIONS = ['left', 'up', 'right', 'down'];
function getNextPositivePosition(currPosition, delta, maxPosition) {
    return (currPosition + delta * DELTA_FACTOR) % maxPosition;
}
function getNextNegativePosition(currPosition, delta, maxPosition) {
    let newPosition = currPosition - delta * DELTA_FACTOR;
    while (newPosition < 0) {
        newPosition += maxPosition;
    }
    return newPosition % maxPosition;
}
function getNewTileX(direction, currTileX, delta, textureDimensionsW) {
    switch (direction) {
        case 'left': {
            return getNextNegativePosition(currTileX, delta, textureDimensionsW);
        }
        case 'right': {
            return getNextPositivePosition(currTileX, delta, textureDimensionsW);
        }
    }
    return currTileX;
}
function getNewTileY(direction, currTileY, delta, textureDimensionsH) {
    switch (direction) {
        case 'up': {
            return getNextNegativePosition(currTileY, delta, textureDimensionsH);
        }
        case 'down': {
            return getNextPositivePosition(currTileY, delta, textureDimensionsH);
        }
    }
    return currTileY;
}
function getNextDirection(currDirection) {
    const currIndex = ALL_DIRECTIONS.indexOf(currDirection);
    const nextIndex = (currIndex + 1) % ALL_DIRECTIONS.length;
    return ALL_DIRECTIONS[nextIndex];
}
export const PokerRoomAnimatedBackground = ({ texture, textureDimensions, stageDimensionsW, stageDimensionsH }) => {
    const startHandTimestampMs = useAppSelector((state) => state.poker.startHandTimestampMs);
    const tilingSpriteRef = useRef(null);
    const directionRef = useRef('left');
    const tileXRef = useRef(0);
    const tileYRef = useRef(0);
    const animate = useCallback((delta) => {
        if (!tilingSpriteRef.current) {
            return;
        }
        tileXRef.current = getNewTileX(directionRef.current, tileXRef.current, delta, textureDimensions.w);
        tileYRef.current = getNewTileY(directionRef.current, tileYRef.current, delta, textureDimensions.h);
        tilingSpriteRef.current.tilePosition.x = tileXRef.current;
        tilingSpriteRef.current.tilePosition.y = tileYRef.current;
    }, [textureDimensions.h, textureDimensions.w]);
    useEffect(() => {
        if (!isConfigFlagEnabled('animatedRoomBackgroundChangesDirection')) {
            return;
        }
        directionRef.current = getNextDirection(directionRef.current);
    }, [startHandTimestampMs]);
    /**
     * Reset tile position if texture changes size (may not matter).
     */
    useEffect(() => {
        tileXRef.current = 0;
        tileYRef.current = 0;
    }, [textureDimensions.w, textureDimensions.h]);
    useTick(animate);
    return (_jsx(TilingSprite, { ref: tilingSpriteRef, texture: texture, width: stageDimensionsW, height: stageDimensionsH, tilePosition: { x: tileXRef.current, y: tileYRef.current } }));
};
